<template>
    <button class="touch-manipulation cursor-pointer disabled:cursor-not-allowed disabled:opacity-50">
        <slot />
    </button>
</template>
